     /**
    myFirebaseApp.js

    Accede a la configuración del proyecto FB que usaré en mi aplicación.
    Las rutas son los nodos a los que accederé a través de los dbXXXXX.
    **********************************************************************************************************************************
 */
import firebase from "firebase";

/* Obtenemos la configuración de nuestro proyecto en Firebase */
var config = {

     apiKey: "AIzaSyCZ1oyLNZg2CKrSO-FkZ0P_MSctBs_0duw",
     authDomain: "topcg-95de7.firebaseapp.com",
     databaseURL: "https://topcg-95de7.firebaseio.com",
     projectId: "topcg-95de7",
     storageBucket: "topcg-95de7.appspot.com",
     messagingSenderId: "399798762836"
};
firebase.initializeApp(config); // Inicializamos la configuración de FB

//? 
//? :¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.
//? Configuración en FB-jcjocop@gmail.com
// const firebaseConfig = {
//      apiKey: "AIzaSyBTOwLPa3tC1H_y9ZkkLyu9jQd251QzHTg",
//      authDomain: "servinsaeval.firebaseapp.com",
//      databaseURL: "https://servinsaeval-default-rtdb.firebaseio.com",
//      projectId: "servinsaeval",
//      storageBucket: "servinsaeval.appspot.com",
//      messagingSenderId: "488374041153",
//      appId: "1:488374041153:web:3f18c5d2b063186480a4c0"
// };

//? Configuración en FB-jcjocop@gmail.com
// const firebaseConfig = {
//      apiKey: "AIzaSyBvoCoMDbP0h4RmkEaNaPPk7HBb0SUNajA",
//      authDomain: "servinsaeval-6667b.firebaseapp.com",
//      databaseURL: "https://servinsaeval-6667b-default-rtdb.firebaseio.com",
//      projectId: "servinsaeval-6667b",
//      storageBucket: "servinsaeval-6667b.appspot.com",
//      messagingSenderId: "977023563164",
//      appId: "1:977023563164:web:43c1805490869cb7448459"
// };

/* Inicializamos la configuración */
// firebase.initializeApp(firebaseConfig); // Inicializamos la configuración de FB

/** Obtenemos las rutas para el nodo de las evaluaciones de:  */
export const rutaEvalTipolo = "/evaluaciones/tipologia";         // Tipología (myers)
export const rutaEvalFactor = "/evaluaciones/factores";          // Factores (16pf)
export const rutaEvalEstabi = "/evaluaciones/estabilidad";       // Estabilidad (npf)
export const rutaEvalSociab = "/evaluaciones/sociabilidad";      // Sociabilidad (cpf)
export const rutaEvalPerfil = "/evaluaciones/perfil";            // Perfil (fig)
export const rutaEvalSuperv = "/evaluaciones/supervision";       // Supervisión (moss)
export const rutaEvalApvtas = "/evaluaciones/aptitudvtas";       // Aptitud den Ventas (tav)
export const rutaEvalSolemp = "/evaluaciones/solemp";            // Solicitud de Empleo
export const rutaEvalEmoc = "/evaluaciones/emociones";           // Emociones
export const rutaEvalVtas2 = "/evaluaciones/orientacion";        // Orientación en Ventas
export const rutaEvalAuxi = "/evaluaciones/auxiliar";            // Auxiliar de Computación
export const rutaEvalAEDP = "/evaluaciones/aedp";            // Auxiliar de Computación

export const rutaUsuarios= "/usuarios";                         // Usuarios del Sistema
export const rutaDeptos  = "/catalogos/deptos";                   // Departamentos del País.
export const rutaCV      = "/cvs"

/**  Accedemos a la Base de datos */
export const db = firebase.database();

/** Direccionamos al nodo correspondiente. */
export const dbEvalTipolo = db.ref(rutaEvalTipolo);
export const dbEvalFactor = db.ref(rutaEvalFactor);
export const dbEvalEstabi = db.ref(rutaEvalEstabi);
export const dbEvalSociab = db.ref(rutaEvalSociab);
export const dbEvalPerfil = db.ref(rutaEvalPerfil);
export const dbEvalSuperv = db.ref(rutaEvalSuperv);
export const dbEvalApvtas = db.ref(rutaEvalApvtas);
export const dbEvalSolemp = db.ref(rutaEvalSolemp);
export const dbEvalEmoc = db.ref(rutaEvalEmoc);
export const dbEvalVtas2 = db.ref(rutaEvalVtas2);
export const dbEvalAuxi = db.ref(rutaEvalAuxi);
export const dbEvalAEDP = db.ref(rutaEvalAEDP);

export const dbUsuarios  = db.ref(rutaUsuarios);
export const dbDeptos    = db.ref(rutaDeptos);
export const dbCV        = db.ref(rutaCV);
/** ================================================================================================================== */

/** Obtenemos las rutas para las carpetas del Storage donde estarán:  */
export const rutaCVs     = "/cvs/";               // Los CVs
export const rutaFotosU  = "/fotosu/";            // Las fotos de los usuarios

/** Accedemos a Storage */
export const stg    = firebase.storage();

/** Direccionamos a la carpeta correspondiente */
export const stgCVs      = stg.ref(rutaCVs);
export const stgFotosU   = stg.ref(rutaFotosU);




// WEBPACK FOOTER //
// ./src/store/myFirebaseApp.js